import { render, staticRenderFns } from "./orderManage.vue?vue&type=template&id=06213d3a&scoped=true&"
import script from "./orderManage.vue?vue&type=script&lang=js&"
export * from "./orderManage.vue?vue&type=script&lang=js&"
import style0 from "./orderManage.vue?vue&type=style&index=0&id=06213d3a&lang=less&scoped=true&"
import style1 from "./orderManage.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06213d3a",
  null
  
)

export default component.exports